export const FOCUS_OUTLINE_CLASS =
  "focus:outline-offset-1 focus:outline-2  focus:outline-solid focus:outline-focus-ring"
